var _linearGradient, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSber = function SvgSber(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 73 64"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "sber_svg__a",
    x1: 36.499,
    x2: 36.499,
    y1: 0.001,
    y2: 63.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00beb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#00d0a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e58d"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sber_svg__a)",
    d: "M56.27 11.123c1.135-1.16 2.208-2.27 3.297-3.36 2.128-2.131 4.266-4.254 6.403-6.377 1.772-1.76 4.224-1.85 5.864-.226 1.638 1.62 1.54 4.055-.242 5.825-8.85 8.789-17.704 17.574-26.55 26.367-3.968 3.942-7.917 7.904-11.878 11.852-2.04 2.032-4.275 2.037-6.32.007-3.452-3.427-6.917-6.835-10.326-10.302-2.036-2.07-1.412-5.279 1.171-6.442 1.478-.665 3.217-.344 4.466.883 2.471 2.429 4.923 4.881 7.384 7.323.146.146.309.277.454.404L50.529 16.66c-1.282-1.575-2.785-2.924-4.442-4.104C32.75 3.045 13.704 9.48 8.98 25.085 4.95 38.409 13.028 52.308 26.66 55.492c12.962 3.028 26.383-5.397 28.969-18.317.476-2.38.44-4.878.472-7.323.038-2.968 2.722-5.008 5.408-3.937 1.51.603 2.391 1.752 2.529 3.383.677 8.14-1.42 15.524-6.386 22.017-5.645 7.378-13.188 11.645-22.455 12.531-16.403 1.566-30-8.995-33.942-22.924-4.59-16.227 3.752-32.649 19.564-38.725C32.805-2.411 46.58.852 55.69 10.457c.166.175.318.362.582.665z"
  })));
};
export default SvgSber;